import React from "react";
import ProductHeader from "../../../../components/Resuseables/ProductsHeader/ProductHeader";
import smsImg from "../../../../assets/images/bulksmshead.png";
// import ProducSubHead from "../../../../components/Resuseables/ProductSubHead/ProducSubHead";

const BulksmsTop = () => {
  return (
    <div className="w-full flex flex-col items-center  gap-10 text-white">
      <ProductHeader title={"BULK SMS"} />
     
    </div>
  );
};

export default BulksmsTop;
